import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { useUser } from 'builder/hooks/useUser'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import useWebsiteHost from 'builder/components/CIO-Dasboard-2.0/hooks/useWebsiteHost'

import { actions } from 'builder/modules/careerProfile'
import { UserSettings } from 'builder/components/Navigation/components/UserSettings'
import { UserProfile } from 'builder/features/navigation/components/UserProfile/UserProfile'
import { useStepByStepFeature } from '../StepByStepFlow/hooks/useStepByStepFeature'
import { BuilderType } from '../ResumeSideMenu/types'
import {
  ButtonContainer,
  CloseIcon,
  Container,
  DashboardButton,
  OpenIcon,
  Profile,
  SettingsContainer,
  ToggleButton,
} from './styles'

interface IProps {
  isOnline: boolean
  isOpen: boolean
  builderType: BuilderType
  setOpen: (key: boolean) => void
  handleDashboardOnClick?: () => void
}

export const Header = ({
  isOnline,
  isOpen,
  builderType,
  setOpen,
  handleDashboardOnClick,
}: IProps) => {
  const user = useUser()
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { getHost } = useWebsiteHost()
  const { isPhone } = useMediaQueries()
  const [isUserDropdownOpen, toggleUserDropdown] = useState(false)
  const { isRbpStepFlowActive } = useStepByStepFeature()

  const openMobileMenu = () => {
    dispatch(actions.setMobileProfileMenu(true))
  }

  const handleOpen = () => {
    const eventName = isOpen ? 'nav_click_close_button' : 'nav_click_super_app_menu'
    trackInternalEvent(eventName, { label: builderType, website_host: getHost })
    setOpen(!isOpen)
  }

  const handleDashboardClick = () => {
    trackInternalEvent('nav_click_dashboard', { label: builderType, website_host: getHost })
    handleDashboardOnClick ? handleDashboardOnClick() : navigate('/')
  }

  return (
    <>
      {!isRbpStepFlowActive && (
        <Container>
          <ToggleButton onClick={handleOpen} data-testid="toggle-sidebar-navigation-button">
            {isOpen ? <CloseIcon /> : <OpenIcon />}
          </ToggleButton>
        </Container>
      )}

      {(!isOpen || isPhone) && !isRbpStepFlowActive && (
        <ButtonContainer>
          <DashboardButton
            onClick={handleDashboardClick}
            data-testid="navigate-to-dashboard-button"
          >
            {i18n.t('builder.side_menu.dashboard')}
          </DashboardButton>
        </ButtonContainer>
      )}

      {isPhone && !isRbpStepFlowActive && (
        <Profile onClick={openMobileMenu}>
          <UserProfile showOnlyAvatar={true} />
        </Profile>
      )}

      {!isPhone && isOnline && user && (
        <SettingsContainer isRbpStepFlowActive={!!isRbpStepFlowActive}>
          <UserSettings user={user} isOpen={isUserDropdownOpen} onToggle={toggleUserDropdown} />
        </SettingsContainer>
      )}
    </>
  )
}
